import { quotationHistoryList } from "constants/quotation";
import * as api from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";
//get job quotation history
export const getJobQuotationHistory = async (dispatch, jobId) => {
  try {
    const res = await api.get_quotation_history_by_ID(jobId);
    dispatch({ type: quotationHistoryList, payload: res.data });
    // return res.data;
  } catch (error) {
    dispatch({
      type: quotationHistoryList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
    // return error?.response?.data || error;
  }
};

//download quotation history
export const downloadQuotationHistory = async (quotationId) => {
  try {
    const res = await api.download_quotation_by_ID(quotationId);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const parsed = JSON.parse(text);
        return {
          status: error.response.status,
          code: parsed.code,
          message: parsed.message,
        };
      } catch {
        return {
          status: error.response.status,
          code: 500,
          message: "Failed to download quotation. Please try again.",
        };
      }
    }
  }
};

// Requote Quotation
export const quotationRequote = async (bodyData) => {
  try {
    const res = await api.requoteQuotation(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

// Requote Reasons List
export const quotationRequoteList = async (filters) => {
  try {
    const res = await api.get_quotation_requote_reason_list(filters);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
